import actionTypes from 'redux/actions/actionTypes';
import initialState from 'redux/initialState';

import { Share } from 'types';

type Action = {
  type: string;
  shares?: Share[];
  share?: Share;
};

const getShares = (action: Action) => action.shares;

const updateShare = (shares: Share[], action: Action) => {
  const currentId = action?.share?.['_id'];

  const updatedShares = shares?.map((share: Share) => {
    if (share['_id'] === currentId) {
      return action.share;
    }
    return share;
  });
  return [...updatedShares];
};

export default function reducer(shares = initialState.shares, action: Action) {
  switch (action.type) {
    case actionTypes.GET_SHARES:
    case actionTypes.SET_SHARES:
      return getShares(action);

    case actionTypes.UPDATE_SHARE:
      return updateShare(shares, action);

    default:
      return shares;
  }
}
